import type { ReactElement } from 'react';
import { Space, Tag } from 'antd';

/** One tag per role, wrapping rather than truncating: a permission can be held by many. */
export const renderRoles = (roles: string[]): ReactElement => (
  <Space size={[4, 4]} wrap>
    {roles.map(role => (
      <Tag key={role}>{role}</Tag>
    ))}
  </Space>
);
